import { faker } from '@faker-js/faker'

import { ServiceOfferListCriteria } from '../../contracts/performance-ad/PartnerServiceOfferListCriteria'
import { TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getServiceOfferListCriteria = asBuilder((): ServiceOfferListCriteria => {
  return {
    filter: {
      isAvailable: faker.datatype.boolean(),
      targetLanguages: faker.helpers.arrayElements(
        [TargetLanguage.KOREAN, TargetLanguage.JAPANESE],
        faker.number.int({ min: 0, max: 3 }),
      ),
    },
    pagination: {
      pageIndex: faker.number.int({ min: 1, max: 100 }),
      pageSize: faker.number.int({ min: 10, max: 100 }),
    },
  }
})
